import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onSendChatInput: ({
	chatInputQuery,
	...props
}: commonAttributesType & {
	chatInputQuery: string;
}) => AnalyticsEventPayload = ({
	chatInputQuery,
	...props
}: commonAttributesType & {
	chatInputQuery: string;
}): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerSendChatInput',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
		},
		nonPrivacySafeAttributes: {
			query,
			chatInputQuery,
		},
	};
};
